import { Box, Grid, IconButton, OutlinedInput } from "@mui/material";
import { BackButton, BackgroundStyle, BigHeading, FlexContainer, LightBlueContainer, ListContainer, SearchingBoxContainer, LongBlueButton, ShortBlueButton, BarContainer, WhiteContainer, LabelContainer, DocumentButton, ButtonContainer, StyledLink, WorkDetailContainer } from "../assets/style";
import RecordTable, { TableRow, TableHeader } from "../components/RecordTable";
import { MouseEventHandler, useRef, useState } from "react";
import SearchInput from "../components/SearchInput";
import SearchDatePicker from "../components/SearchDatePicker";
import dayjs from 'dayjs';
import SearchBox from "../components/SearchBox";
import ProjectBar from "../components/ProjectBar";
import FormButton from "../components/FormButton";
import FormLabel from "../components/FormLabel";
import axios from "axios";
import { deleteIcon } from "../assets/imgs";
import FormLongLabel from "../components/FormLongLabel";
import { useLocation, useNavigate } from "react-router-dom";
import MainContent from '../components/MainContent';
import BigMapCard from '../components/MapBigCard'
import { workPageName } from "../components/PageName";
import { useTranslation } from "react-i18next";

const WorkRecordDetailPage = () => {
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    const getLocation = useLocation();
    const work = getLocation.state?.work;
    console.log(work)
    // const [projectNum, setProjectNum] = useState("");
    // const [date, setDate] = useState(dayjs());
    // const [projectName, setProjectName] = useState("");
    // const [location, setLocation] = useState("");
    const [riskAssessment, setRiskAssessment] = useState<string | null>("1.jpg");
    const [workPermit, setWorkPermit] = useState<string | null>("2.jpg");
    // const workPermitFileInputRef = useRef<HTMLInputElement>(null);
    // const riskAssessmentFileInputRef = useRef<HTMLInputElement>(null);
    // For tesing
    const [selectPosition, setSelectPosition] = useState(
        {
            project_id: 1,
            project_name: "Vision Peak Solutions company",
            place_id: 1,
            name: '太子6567567',
            lat: 22.32538,
            lng: 114.18028,
            detail: 'location 1 location detail abcefg abcefg 123123',
            date: "18/01/2024",
            on_site_day: 5
        });

    // For tesing
    function getFileNameFromUrl(url: any) {
        console.log("Get File Name ")
        const parts = url.split('/');
        return parts[parts.length - 1];
    }

    const EquipmentColumns: TableHeader[] = [
        { field: 'type', headerName: t('Type'), width: 200, isSortable: true },
        { field: 'rfid', headerName: t('RFID No.'), width: 200, isSortable: false },
        { field: 'equirmentNum', headerName: t('Equipment No.'), width: 200, isSortable: false },
        { field: 'equirmentName', headerName: t('Equipment Name'), width: 200, isSortable: false },
        { field: 'manufacturer', headerName: t('Brand / Manufacturer'), width: 300, isSortable: true },
        { field: 'modelNum', headerName: t('Model No.'), width: 200, isSortable: false },
        { field: 'purchaseDate', headerName: t('Purchase Date'), width: 300, isSortable: false },
        { field: 'expiryDate', headerName: t('Expiry Date'), width: 300, isSortable: false },
        { field: 'certDueDate', headerName: t('Next Cal. / Cert Due Date'), width: 200, isSortable: false },
        { field: 'calPeriod', headerName: t('Cal. Period'), width: 200, isSortable: false },
        { field: 'certification', headerName: t('Certification'), width: 200, isSortable: false },
        { field: 'qrCode', headerName: t('QR Code'), width: 200, isSortable: false },
    ];

    // const EquipmentRows = null;
    // const WorkerRows1 = null;
    // const WorkerRows2 = null;
    const EquipmentRows = [
        {
            id: 1,
            type: "PPE",
            rfid: "158497",
            equirmentNum: "US-ME-20-111-01",
            equirmentName: "BW Gas Detector, GasAlertMax XT II",
            manufacturer: "BW",
            modelNum: "XT-XWHM-Y-OR",
            purchaseDate: "01/01/2021",
            expiryDate: "01/01/2024",
            certDueDate: "01/01/2024",
            calPeriod: "1 Year",
            certification: "certification 1",
            qrCode: "QR 1",
        },
        {
            id: 2,
            type: "PPE",
            rfid: "158497",
            equirmentNum: "US-ME-20-111-01",
            equirmentName: "BW Gas Detector, GasAlertMax XT II",
            manufacturer: "BW",
            modelNum: "XT-XWHM-Y-OR",
            purchaseDate: "01/01/2021",
            expiryDate: "01/01/2024",
            certDueDate: "01/01/2024",
            calPeriod: "1 Year",
            certification: "certification 1",
            qrCode: "QR 1",
        }
    ];
    const WorkerRows1 = [
        {
            id: 1,
            type: "PPE",
            rfid: "158497",
            equirmentNum: "US-ME-20-111-01",
            equirmentName: "BW Gas Detector, GasAlertMax XT II",
            manufacturer: "BW",
            modelNum: "XT-XWHM-Y-OR",
            purchaseDate: "01/01/2021",
            expiryDate: "01/01/2024",
            certDueDate: "01/01/2024",
            calPeriod: "1 Year",
            certification: "certification 1",
            qrCode: "QR 1",
        },
        {
            id: 2,
            type: "PPE",
            rfid: "158497",
            equirmentNum: "US-ME-20-111-01",
            equirmentName: "BW Gas Detector, GasAlertMax XT II",
            manufacturer: "BW",
            modelNum: "XT-XWHM-Y-OR",
            purchaseDate: "01/01/2021",
            expiryDate: "01/01/2024",
            certDueDate: "01/01/2024",
            calPeriod: "1 Year",
            certification: "certification 1",
            qrCode: "QR 1",
        }
    ];
    const WorkerRows2 = [
        {
            id: 1,
            type: "PPE",
            rfid: "158497",
            equirmentNum: "US-ME-20-111-01",
            equirmentName: "BW Gas Detector, GasAlertMax XT II",
            manufacturer: "BW",
            modelNum: "XT-XWHM-Y-OR",
            purchaseDate: "01/01/2021",
            expiryDate: "01/01/2024",
            certDueDate: "01/01/2024",
            calPeriod: "1 Year",
            certification: "certification 1",
            qrCode: "QR 1",
        },
        {
            id: 2,
            type: "PPE",
            rfid: "158497",
            equirmentNum: "US-ME-20-111-01",
            equirmentName: "BW Gas Detector, GasAlertMax XT II",
            manufacturer: "BW",
            modelNum: "XT-XWHM-Y-OR",
            purchaseDate: "01/01/2021",
            expiryDate: "01/01/2024",
            certDueDate: "01/01/2024",
            calPeriod: "1 Year",
            certification: "certification 1",
            qrCode: "QR 1",
        }
    ];

    return (
        // <MainContent>
        <MainContent type={workPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <ListContainer className="data-table-overide-styles">
                    <BigHeading>Work Record</BigHeading>
                    <SearchingBoxContainer>
                        {/* <SearchBox>
                        <FlexContainer>
                            <SearchInput title={"Project No."} value={projectNum} setMethod={setProjectNum} />
                            <SearchInput title={"Project Name"} value={projectName} setMethod={setProjectName} />
                        </FlexContainer>
                        <FlexContainer>
                            <SearchInput title={"Location of Confined Space"} value={location} setMethod={setLocation} />
                            <SearchDatePicker title={"Date"} value={date} setMethod={setDate} />
                        </FlexContainer>
                        <FlexContainer>
                            <SubmitButton>Search</SubmitButton>
                        </FlexContainer>
                    </SearchBox> 
                    */}
                        {/* ~~Map card~~ */}
                        <Grid container spacing={1.5} >
                            <Grid item xs={12} sm={7}>
                                <WorkDetailContainer>
                                    <Box >
                                        <ProjectBar />
                                    </Box>
                                    <Box >
                                        <WhiteContainer sx={{ height: '100%', minHeight: "480px" }}>
                                            {/* <Box sx={{ margin: '20px' }}> */}
                                            <BigMapCard selectPosition={selectPosition} isInput={false} />

                                            {/* </Box> */}
                                        </WhiteContainer>
                                    </Box>
                                </WorkDetailContainer>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <WorkDetailContainer>
                                    <Box >
                                        <WhiteContainer sx={{ height: '100%', minHeight: "190px" }}>
                                            <Box>
                                                <BigHeading>{t("Document")}</BigHeading>
                                                <Box sx={{ m: '10px' }}>
                                                    {/* <FormButton title={"Risk Assessment"} value={riskAssessment} setMethod={uploadRiskAssessment} buttonName={"Select File"} onClick={getFileNameFromUrl} /> */}
                                                    <ButtonContainer>
                                                        <LabelContainer>
                                                            {t("Risk Assessment: ")}
                                                        </LabelContainer>
                                                        {riskAssessment && <a style={{ marginLeft: "10px" }} href={riskAssessment} target="_blank" rel="noopener noreferrer">{getFileNameFromUrl(riskAssessment)}</a>}
                                                    </ButtonContainer>
                                                    <ButtonContainer>
                                                        <LabelContainer>
                                                            {t("Work Permit: ")}
                                                        </LabelContainer>
                                                        {workPermit && <StyledLink href={workPermit} target="_blank" rel="noopener noreferrer">{getFileNameFromUrl(workPermit)}</StyledLink>}
                                                    </ButtonContainer>
                                                </Box>
                                            </Box>
                                        </WhiteContainer>
                                    </Box>
                                    <Box >
                                        <WhiteContainer sx={{ height: '100%', minHeight: "260px", mt: '20px' }}>
                                            <Box>
                                                <BigHeading>{t("On Site Worker")}</BigHeading>
                                                <Box sx={{ m: '10px' }}>
                                                    <FormLongLabel title={t("Competent person")} content={"***"} />
                                                    <FormLongLabel title={t("Standby Person")} content={"***"} />
                                                    <FormLongLabel title={t("Personnel Entering - Worker 1")} content={"***"} />
                                                    <FormLongLabel title={t("Personnel Entering - Worker 2")} content={"***"} />
                                                </Box>
                                            </Box>
                                        </WhiteContainer>
                                    </Box>
                                </WorkDetailContainer>
                            </Grid>
                        </Grid>
                    </SearchingBoxContainer>
                    <BigHeading>{t("On Site Equipment")}</BigHeading>
                    {EquipmentRows && <RecordTable
                        columns={EquipmentColumns}
                        rows={EquipmentRows}
                        checkbox={false}
                    // color="#8BB0DB"
                    />}
                    {!EquipmentRows && <RecordTable
                        columns={EquipmentColumns}
                        checkbox={false}
                    // color="#8BB0DB"
                    />}
                    <BigHeading>{t("Certified Worker 1")}</BigHeading>
                    {WorkerRows1 && <RecordTable
                        columns={EquipmentColumns}
                        rows={WorkerRows1}
                        checkbox={false}
                    // color="#8BB0DB"
                    />}
                    {!WorkerRows1 && <RecordTable
                        columns={EquipmentColumns}
                        checkbox={false}
                    // color="#8BB0DB"
                    />}
                    <BigHeading>{t("Certified Worker 2")}</BigHeading>
                    {WorkerRows2 && <RecordTable
                        columns={EquipmentColumns}
                        rows={WorkerRows2}
                        checkbox={false}
                    // color="#8BB0DB"
                    />}
                    {!WorkerRows2 && <RecordTable
                        columns={EquipmentColumns}
                        checkbox={false}
                    // color="#8BB0DB"
                    />}
                    <Box sx={{ display: "row" }}>
                        <BackButton onClick={() => navigate('/work')} >{t("Back")}</BackButton>
                    </Box>
                </ListContainer>
            </BackgroundStyle >
        </MainContent>
    );
};
export default WorkRecordDetailPage;